import { action } from '@storybook/addon-actions';

export default {
  title: 'Components/Radio Button',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-radiobutton\` component, pass the following props:

\`\`\`html
<dda-radiobutton
    title_text="Radio Button Title"
    checked="false"
    size="md"
    variants="normal"
    supporting="Supporting Text"
    group_name="radiogroup"
    input_id="testId"
    custom_class=""
    component_mode=""
    aria_label="radio-button"
></dda-radiobutton>
\`\`\`
        `,
      },
    },
  },
  argTypes: {
    title_text: {
      control: 'text',
      description: 'Title for the radiobutton',
    },
    supporting: {
      control: 'text',
      description: 'Supporting Text',
    },
    error_message: {
      control: 'text',
      description: 'Error message text',
    },
    validation_type: {
      control: { type: 'select' },
      options: ['normal', 'error'],
      description: 'Validation type of the input field',
    },
    validation_id: {
      control: 'text',
      description: 'Validation ID of helper text and error text',
    },
    group_name: {
      control: 'text',
      description: 'Radio group name',
    },
    input_id: {
      control: 'text',
      description: 'Unique ID for input',
    },
    checked: {
      control: 'boolean',
      description: 'Checked state of the radiobutton',
    },
    size: {
      control: { type: 'select' },
      options: ['small', 'default'],
    },
    variants: {
      control: { type: 'select' },
      options: ['normal', 'outlined', 'faded'],
    },
    custom_class: {
      control: 'text',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the radio button component',
    },
    aria_label: {
      control: 'text',
      description: 'Aria label for the radio button',
    },
    radio_status: {
      control: { type: 'select' },
      options: ['normal', 'disabled'],
    },
  },
};

const Template = (args) => {
  const container = document.createElement('div');
  const radio = document.createElement('dda-radiobutton');

  Object.entries(args).forEach(([key, value]) => {
    if (typeof value === 'boolean') {
      if (value) radio.setAttribute(key, '');
    } else if (value !== undefined && value !== '') {
      radio.setAttribute(key, String(value));
    }
  });

  radio.addEventListener('radioChange', action('radioChange'));
  container.appendChild(radio);
  return container;
};

export const DefaultRadio = Template.bind({});
DefaultRadio.args = {
  title_text: 'Radio Button Title',
  checked: false,
  size: 'default',
  variants: 'normal',
  supporting: 'Supporting Text',
  error_message: 'Error text',
  validation_id: 'validationId',
  group_name: 'radiogroup',
  input_id: 'testId1',
  custom_class: '',
  component_mode: '',
  aria_label: 'radio-button',
  validation_type: 'normal',
  radio_status: 'normal',
};

export const CheckedRadio = Template.bind({});
CheckedRadio.args = {
  ...DefaultRadio.args,
  checked: true,
  input_id: 'testId2',
};
